import LastRefreshHeader from '@/react_app/components/BillingUsage/Overview/LastRefreshHeader';
import OverviewSection from '@/react_app/components/BillingUsage/Overview/OverviewSection';
import { OverviewSectionWithRefreshProps } from '@/react_app/components/BillingUsage/Overview/types';

const OverviewSectionWithRefresh = ({ overviewSection, refreshHeaderSection }: OverviewSectionWithRefreshProps) => (
	<div>
		<LastRefreshHeader {...refreshHeaderSection} />
		<OverviewSection {...overviewSection} />
	</div>
);

export default OverviewSectionWithRefresh;
